// extracted by mini-css-extract-plugin
export default {"pagination":"Paginator_pagination__srf9R"};